/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_S2_DescInputs */

const en_landing_how_s2_desc = /** @type {(inputs: Landing_How_S2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate a new image, or upload one, paint the area to change and describe the edit. Check the credit quote and submit once.`)
};

const zh_landing_how_s2_desc = /** @type {(inputs: Landing_How_S2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成新图，或上传图片、涂出要改的区域并描述修改。确认积分报价后提交。`)
};

/**
* | output |
* | --- |
* | "Generate a new image, or upload one, paint the area to change and describe the edit. Check the credit quote and submit once." |
*
* @param {Landing_How_S2_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_how_s2_desc = /** @type {((inputs?: Landing_How_S2_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_S2_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_how_s2_desc(inputs)
	return zh_landing_how_s2_desc(inputs)
});
export { landing_how_s2_desc as "landing.how.s2_desc" }